/* Desktop-Navigation 2026 - Skript zu snippets/dn-mega-2026.liquid.
   Ausgelagert (2026-09-06, Audit vor dem Livegang): als Inline-Script wog es
   12,8 KB in jeder Seite; als Asset holt der Browser es einmal und nimmt es
   danach aus dem Zwischenspeicher. Enthaelt kein Liquid. Laeuft mit defer,
   boot() unten prueft readyState selbst. */
  (function () {
/* Das Snippet kann zweimal im Dokument stehen (Haupt- und untere
   Navigation). Die dokumentweiten Zuhoerer sollen es trotzdem nur einmal
   geben. */
if (window.__dnMega2026) return;
window.__dnMega2026 = true;

/* ---- Kategorien-Umschalter ---- */
function wire(panel) {
  if (panel.dataset.dnCats === '1') return;
  panel.dataset.dnCats = '1';
  var cats = panel.querySelectorAll('.dn-cat');
  var subs = panel.querySelectorAll('.dn-sub');
  function show(key) {
    cats.forEach(function (c) {
      var an = c.dataset.key === key;
      c.classList.toggle('is-active', an);
      /* aria-current sagt Screenreadern, zu welcher Kategorie die Unterpunkte
         in der mittleren Spalte gehoeren (Audit 2026-09-10). */
      if (an) c.setAttribute('aria-current', 'true'); else c.removeAttribute('aria-current');
    });
    subs.forEach(function (s) { s.hidden = s.dataset.sub !== key; });
  }
  function subZu(key) { return panel.querySelector('.dn-sub[data-sub="' + key + '"]'); }
  cats.forEach(function (c, i) {
    c.addEventListener('mouseenter', function () { show(c.dataset.key); });
    c.addEventListener('focus', function () { show(c.dataset.key); });
    /* Tastatur (Audit 2026-09-10): jede fokussierte Kategorie blendet ihre eigenen
       Unterpunkte ein, mit Tab allein kam man deshalb nur zu denen der letzten
       Kategorie. Pfeil runter/hoch wechselt die Kategorie, Pfeil rechts springt in
       ihre Unterpunkte, Pfeil links fuehrt von dort zurueck (Hinweis fuer
       Screenreader steht als visually-hidden vor den Kategorien). */
    c.addEventListener('keydown', function (e) {
      var ziel = null;
      if (e.key === 'ArrowDown') ziel = cats[i + 1];
      else if (e.key === 'ArrowUp') ziel = cats[i - 1];
      else if (e.key === 'ArrowRight') { var s = subZu(c.dataset.key); ziel = s && s.querySelector('a, button'); }
      if (!ziel) return;
      e.preventDefault();
      ziel.focus();
    });
    /* Touch ohne Hover (iPad quer, ab 1200px): der erste Tipp auf eine noch nicht
       aktive Kategorie zeigt ihre Unterpunkte, erst der zweite oeffnet die Seite -
       wie das Theme es bei den Hauptpunkten haelt. pointerdown kommt vor dem
       emulierten mouseenter, der die Kategorie sonst schon aktiv gesetzt haette. */
    c.addEventListener('pointerdown', function (e) {
      c.dataset.dnTipp = e.pointerType === 'touch' && !c.classList.contains('is-active') ? '1' : '';
    });
    c.addEventListener('click', function (e) {
      if (c.dataset.dnTipp === '1') { e.preventDefault(); show(c.dataset.key); }
      c.dataset.dnTipp = '';
    });
  });
  subs.forEach(function (s) {
    s.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft') return;
      var c = panel.querySelector('.dn-cat[data-key="' + s.dataset.sub + '"]');
      if (!c) return;
      e.preventDefault();
      c.focus();
    });
  });
}

/* ---- Promo-Bilder erst bei Beruehrung der Navigation holen ----
   Die Panels stehen im Markup, sind aber nur unsichtbar geschaltet, nicht
   ausgeblendet - ein Hintergrundbild im Stilattribut wuerde deshalb auf
   jeder Seite mitgeladen, auch wenn das Menue nie aufgeht. Die Adresse
   steht in data-dn-bg und wird gesetzt, sobald jemand den Menuepunkt
   beruehrt oder hineinspringt: frueh genug, dass das Bild bis zum
   Oeffnen da ist, und gar nicht fuer alle anderen.
   Seit dem Audit 2026-09-10 je Panel (wurzel = das li des Punktes): vorher
   holte der erste Kontakt mit der Navigation die Bilder aller Panels auf
   einmal - 55 Anfragen in CH, obwohl nur ein Panel aufging. */
function bilderHolen(wurzel) {
  wurzel = wurzel || document;
  wurzel.querySelectorAll('.dn-mega [data-dn-bg]').forEach(function (el) {
    el.style.backgroundImage = "url('" + el.dataset.dnBg + "')";
    el.removeAttribute('data-dn-bg');
  });
  /* Poster der Kachel-Videos ebenfalls erst jetzt (dn-video-tag mit
     poster_lazy): sonst holte der Browser es beim Seitenaufruf, obwohl
     das Menue zu ist. */
  wurzel.querySelectorAll('.dn-mega video[data-dn-poster]').forEach(function (v) {
    v.setAttribute('poster', v.dataset.dnPoster);
    v.removeAttribute('data-dn-poster');
  });
  wurzel.querySelectorAll('.dn-mega img[data-dn-src]').forEach(function (img) {
    if (img.dataset.dnSrcset) img.setAttribute('srcset', img.dataset.dnSrcset);
    img.setAttribute('src', img.dataset.dnSrc);
    img.removeAttribute('data-dn-src');
    img.removeAttribute('data-dn-srcset');
  });
}

/* ---- Durchgehend offen beim Wechsel ----
   Laeuft nur, wenn schon ein Panel offen ist. Dann ist der Zeiger
   erkennbar im Menue unterwegs und nicht auf dem Weg woanders hin. */
function schonOffen() {
  var link = document.querySelector('.dn-nav__link[aria-expanded="true"]');
  if (link) return link;
  /* Beim schnellen Hin und Her ist das Theme mit dem Oeffnen (100ms) noch
     nicht durch, das Panel steht aber schon per dn-sofort da - auch das
     ist eine laufende Sitzung. */
  var sofort = document.querySelector('.dn-nav__item > .dn-mega.dn-sofort');
  return sofort ? sofort.parentElement.querySelector('.dn-nav__link[aria-controls]') : null;
}

/* Beim Wechsel steht das neue Panel sofort da (dn-sofort), sein Inhalt
   gleitet kurz herein: Spalten gestaffelt, 220ms, 40ms Versatz. Die
   Animation traegt die Kennung dn-wechsel, damit der open-Handler unten
   nur die des Themes abbricht, nicht diese. Bei reduzierter Bewegung
   erscheint der Inhalt einfach. */
function einblenden(panel, versatz) {
  if (!panel.animate) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  versatz = versatz || 0;
  panel.dataset.dnWechselStart = String(performance.now() - versatz);
  panel.querySelectorAll('.mega-menu__column').forEach(function (el, i) {
    el.getAnimations().forEach(function (a) { a.cancel(); });
    el.style.opacity = '';
    var a = el.animate(
      [{ opacity: 0, transform: 'translateY(10px)' }, { opacity: 1, transform: 'none' }],
      { duration: 220, delay: 40 * i, easing: 'cubic-bezier(0.65, 0, 0.35, 1)', fill: 'backwards' }
    );
    a.id = 'dn-wechsel';
    if (versatz) a.currentTime = versatz;
  });
}
function wechselAbbrechen(panel) {
  panel.querySelectorAll('.mega-menu__column').forEach(function (el) {
    el.getAnimations().forEach(function (a) { if (a.id === 'dn-wechsel') a.cancel(); });
  });
}

function wechselVerdrahten(li) {
  if (li.dataset.dnWechsel === '1') return;
  li.dataset.dnWechsel = '1';
  var panel = li.querySelector('.dn-mega');
  if (!panel) return;

  /* Bilder nur fuer dieses Panel - pointerenter kommt vor dem 100ms-Timer des
     Themes, focusin fuer die Tastatur (Audit 2026-09-10). */
  ['pointerenter', 'focusin'].forEach(function (t) {
    li.addEventListener(t, function () { bilderHolen(li); }, { once: true });
  });

  li.addEventListener('mouseenter', function () {
    panel.classList.remove('dn-weg');
    var offen = schonOffen();
    if (!offen || offen.parentElement === li) return;
    /* Das alte Panel sofort weg (Roman, 2026-09-10): das Theme haelt es noch 250ms,
       und weil Shop hoeher ist als die anderen, schaute es unter dem neuen hervor.
       Die Klasse faellt, sobald das Theme hidden setzt (Beobachter unten) oder der
       Zeiger auf den Punkt zurueckkehrt (mouseenter oben). */
    var altes = offen.parentElement.querySelector('.dn-mega');
    if (altes && altes !== panel) altes.classList.add('dn-weg');
    panel.classList.add('dn-sofort');
    einblenden(panel);
  });
  li.addEventListener('mouseleave', function () {
    panel.classList.remove('dn-sofort');
    if (panel.hidden) wechselAbbrechen(panel);
    offenPflegen();
  });
  waechterVerdrahten(li, panel);
}

/* ---- Waechter: offen, solange der Zeiger auf dem Punkt ruht ----
   Drei Luecken im Theme liessen das Menue zu, obwohl der Zeiger auf einem
   Punkt stand (Roman, 2026-09-06: schneller Wechsel Tutorials -> Inspiration):
   1. Es oeffnet nur bei mouseenter mit relatedTarget - kommt der Zeiger vom
      Fensterrand (Tableiste) direkt auf den Punkt, passiert nichts.
   2. Sein Oeffnen-Timer bricht ab, wenn aria-expanded schon "true" steht.
   3. Sein Schliess-Timer (250ms nach dem Verlassen) setzt hidden auch dann,
      wenn der Punkt inzwischen wieder betreten und geoeffnet wurde. Dann
      steht ein verstecktes Panel mit aria-expanded="true" da, das Theme
      haelt es fuer offen und oeffnet es nie wieder (Punkt 2).
   Der Waechter prueft 180ms und 450ms nach dem Betreten: ruht der Zeiger noch
   auf dem Punkt und das Panel ist zu, setzt er aria zurueck und laesst das
   Theme regulaer oeffnen - ueber dessen openDropdown, damit auch dessen
   Zuhoerer fuers Schliessen wieder haengen. Ein Beobachter nimmt Fall 3
   sofort zurueck: hidden an einem Panel, dessen Punkt aria-expanded="true"
   traegt, ist ein verspaeteter Schliess-Timer - bei Zeiger auf dem Punkt
   wieder aufmachen, sonst nur aria bereinigen. */
function waechterVerdrahten(li, panel) {
  var nav = li.closest('desktop-navigation');
  var link = li.querySelector('.dn-nav__link[aria-controls]');
  if (!nav || !link) return;

  function offenErzwingen() {
    if (!li.matches(':hover')) return;
    if (li.hasAttribute('data-dn-zu')) return;
    var aria = link.getAttribute('aria-expanded') === 'true';
    if (!panel.hidden && (aria || panel.classList.contains('dn-sofort'))) return;
    link.setAttribute('aria-expanded', 'false');
    panel.classList.remove('is-closing');
    if (typeof nav.openDropdown === 'function') nav.openDropdown(li);
  }
  li.addEventListener('pointerenter', function () {
    setTimeout(offenErzwingen, 180);
    setTimeout(offenErzwingen, 450);
  });

  if (!window.MutationObserver) return;
  new MutationObserver(function () {
    if (!panel.hidden) return;
    panel.classList.remove('dn-weg');
    if (link.getAttribute('aria-expanded') !== 'true') return;
    if (li.matches(':hover') && !li.hasAttribute('data-dn-zu')) {
      panel.removeAttribute('hidden');
      panel.classList.remove('is-closing');
    } else {
      link.setAttribute('aria-expanded', 'false');
      offenPflegen();
    }
  }).observe(panel, { attributes: true, attributeFilter: ['hidden'] });
}

/* Das Theme setzt beim Oeffnen alle Spalten auf durchsichtig und blendet
   sie gestaffelt ein. Beim Wechsel steht das Panel dank dn-sofort schon
   da und der Inhalt gleitet bereits herein (einblenden) - die Theme-
   Animation wuerde ihn wegnehmen und neu aufbauen. Also nur die des
   Themes abbrechen, sobald es sein Oeffnen meldet; das Ereignis kommt im
   selben Durchlauf wie sein opacity = 0, dazwischen wird kein Bild
   gezeichnet. */
document.addEventListener('desktop-nav:dropdown:open', function () {
  var offen = schonOffen();
  var panel = offen && offen.parentElement.querySelector('.dn-mega.dn-sofort');
  if (!panel) return;
  /* Das Theme hat soeben alle Animationen der Spalten abgebrochen - auch
     unser Gleiten (gemessen: nach seinem Oeffnen war keine mehr da) - und
     opacity = 0 gesetzt. Also das Gleiten mit dem verstrichenen Versatz
     neu aufsetzen, es laeuft nahtlos weiter; ist es schon durch (380ms
     bei fuenf Spalten), nur das Reset des Themes zuruecknehmen. */
  var start = parseFloat(panel.dataset.dnWechselStart || '');
  var versatz = isNaN(start) ? Infinity : performance.now() - start;
  if (versatz < 400) { einblenden(panel, versatz); return; }
  panel.querySelectorAll('.mega-menu__column').forEach(function (el) {
    el.getAnimations().forEach(function (a) { if (a.id !== 'dn-wechsel') a.cancel(); });
    el.style.opacity = '';
  });
});

/* ---- Vergleichsschalter fuer das Menue ----
   ?dn_menu=on setzt das Cart-Attribut dn_menu_v2 auf on (v2 erzwingen),
   ?dn_menu=off auf off (altes Menue dn-menu-desktop-2026 zum Vergleich);
   dn-header liest es nur fuer diese Sitzung. Danach laedt die Seite ohne
   den Parameter neu. Seit 2026-09-06 ist v2 ohnehin die Einstellung. */
(function () {
  var q = new URLSearchParams(location.search);
  var m = q.get('dn_menu');
  if (m !== 'on' && m !== 'off') return;
  fetch('/cart/update.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ attributes: { dn_menu_v2: m === 'on' ? 'on' : 'off' } })
  }).then(function () {
    q.delete('dn_menu');
    var rest = q.toString();
    location.replace(location.pathname + (rest ? '?' + rest : '') + location.hash);
  }).catch(function () {});
})();

/* ---- Kachelreihe: Mausrad scrollt waagerecht ----
   Die Reihe zeigt 2,5 Kacheln und laeuft waagerecht wie im Mobilmenue.
   Ein Trackpad wischt seitwaerts von selbst; ein Mausrad kennt nur hoch
   und runter, deshalb wird senkrechtes Drehen ueber der Reihe in
   seitliches Scrollen uebersetzt - nur solange die Reihe in dieser
   Richtung noch Weg hat, sonst laeuft das Rad wie gewohnt weiter. */
function radVerdrahten(reihe) {
  reihe.addEventListener('wheel', function (e) {
    if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
    var max = reihe.scrollWidth - reihe.clientWidth;
    if (max <= 0) return;
    var schritt = e.deltaMode === 1 ? e.deltaY * 16 : e.deltaY;
    var ziel = Math.max(0, Math.min(max, reihe.scrollLeft + schritt));
    if (ziel === reihe.scrollLeft) return;
    e.preventDefault();
    reihe.scrollLeft = ziel;
  }, { passive: false });
}

/* ---- Gleiche Hoehe fuer alle v2-Panels ----
   Beim ersten Beruehren der Navigation werden alle Panels unsichtbar ausgemessen
   (hidden kurz weg, visibility hidden, keine Uebergaenge), das hoechste Mass wird
   ueber --dn-mega-h zur Mindesthoehe aller. Bei jedem Oeffnen wird nachgemessen,
   falls ein Panel gewachsen ist (aufgeklappte Gruppe); bei Groessenaenderung des
   Fensters von vorn, weil die Spalten mit der Breite schrumpfen. */
var dnMegaH = 0;
/* Nie hoeher als der Platz unter der Kopfzeile (Audit 2026-09-10: bei 1280x720 endete
   das angeglichene Panel bei 726px, unter dem Fensterrand). Den Rest - Inhalt hoeher als
   der Platz - deckt max-height mit overflow-y im CSS, das Panel scrollt dann innen. */
function platzUnten() {
  var nav = document.querySelector('.dn-nav--v2');
  var unten = nav ? nav.getBoundingClientRect().bottom : 120;
  return Math.max(240, window.innerHeight - unten - 16);
}
function hoeheMerken(px) {
  px = Math.min(px, platzUnten());
  if (!(px > dnMegaH)) return;
  dnMegaH = px;
  document.documentElement.style.setProperty('--dn-mega-h', px + 'px');
}
function hoehenAngleichen() {
  document.querySelectorAll('.dn-nav__item > .dn-mega--v2').forEach(function (panel) {
    var inner = panel.querySelector('.dn-mega__inner');
    if (!inner) return;
    if (!panel.hidden) { hoeheMerken(inner.offsetHeight); return; }
    var alt = panel.getAttribute('style');
    panel.style.cssText = (alt || '') + ';visibility:hidden !important;transition:none !important;';
    panel.hidden = false;
    hoeheMerken(inner.offsetHeight);
    panel.hidden = true;
    if (alt === null) panel.removeAttribute('style'); else panel.setAttribute('style', alt);
  });
}
var dnHoeheTimer;
window.addEventListener('resize', function () {
  clearTimeout(dnHoeheTimer);
  dnHoeheTimer = setTimeout(function () {
    dnMegaH = 0;
    document.documentElement.style.removeProperty('--dn-mega-h');
    hoehenAngleichen();
  }, 200);
});
document.addEventListener('desktop-nav:dropdown:open', function () {
  var offen = schonOffen();
  var panel = offen && offen.parentElement.querySelector('.dn-mega--v2');
  var inner = panel && panel.querySelector('.dn-mega__inner');
  if (inner) hoeheMerken(inner.offsetHeight);
});

function boot() {
  document.querySelectorAll('.dn-mega--cats').forEach(wire);
  document.querySelectorAll('.dn-mega-neu__reihe').forEach(radVerdrahten);
  document.querySelectorAll('.dn-nav__item.has-dropdown').forEach(wechselVerdrahten);
  var nav = document.querySelector('.dn-nav');
  if (nav && !nav.dataset.dnBereit) {
    nav.dataset.dnBereit = '1';
    ['pointerenter', 'focusin'].forEach(function (t) {
      nav.addEventListener(t, hoehenAngleichen, { once: true });
    });
  }
}

/* ---- Sticht die Seite ab, sticht auch die Sticky-Leiste ab ----
   Und die Kachel-Videos im Panel laufen nur, solange es offen ist:
   Start beim Oeffnen (ausser bei reduzierter Bewegung), Pause beim
   Schliessen - wie im Mobilmenue. */
var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function kachelVideos(an) {
  document.querySelectorAll('.dn-mega video.dn-mega-neu__video').forEach(function (v) {
    if (!an) { v.pause(); return; }
    if (ruhig) return;
    var offen = v.closest('.dn-mega');
    if (!offen || offen.hidden) return;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  });
}
/* ---- Ein Zustand fuer Schleier und dn-mega-offen ----
   Bisher hing beides an den Einzelereignissen des Themes: close nahm
   die Klasse sofort weg, open setzte sie 100ms spaeter wieder - beim
   Wechsel zwischen zwei Punkten blitzte alles, was daran haengt (die
   Sticky-Leiste der Produktseite), kurz hell. Und die Theme-Schleier je
   Panel lagen dabei rund 250ms doppelt (gemessen 0,5 -> 0,71 -> 0,5).
   Jetzt folgt beides der Frage "ist irgendein Punkt offen" - schonOffen
   zaehlt auch das per dn-sofort gezeigte Panel, die Antwort bleibt
   waehrend eines Wechsels also durchgehend ja. Der Schleier ist in v2
   ein einziges Element (.dn-mega-schleier), die Theme-Schleier sind dort
   abgeschaltet. */
var schleier = document.querySelector('.dn-mega-schleier');
function offenPflegen() {
  var an = !!schonOffen();
  document.documentElement.classList.toggle('dn-mega-offen', an);
  if (schleier) schleier.classList.toggle('is-an', an);
}
document.addEventListener('desktop-nav:dropdown:open', function () {
  offenPflegen();
  kachelVideos(true);
});
/* Aufklappbare Gruppen in der mittleren Spalte (Roman, 2026-09-10): Klick auf die
   Zeile zeigt die Chips, ein zweiter Klick schliesst sie wieder. Die Gruppen sind
   unabhaengig voneinander; der Zustand bleibt, bis die Seite neu laedt. */
document.addEventListener('click', function (e) {
  var t = e.target.closest('.dn-sub__toggle');
  if (!t) return;
  e.preventDefault();
  var g = t.closest('.dn-sub__gruppe');
  if (!g) return;
  var offen = g.classList.toggle('is-open');
  t.setAttribute('aria-expanded', offen ? 'true' : 'false');
});

document.addEventListener('desktop-nav:dropdown:close', function () {
  offenPflegen();
  kachelVideos(false);
});

/* ---- Tastatur ----
   Das Theme macht das Panel schon sichtbar, sobald der Ausloeser den
   Fokus hat (:focus-within im Theme-CSS). Es dreht dabei aber
   aria-expanded nicht mit, sodass die Ansage das Gegenteil dessen
   behauptet, was auf dem Schirm steht. Hier nachgezogen.

   Escape schliesst und gibt den Fokus zurueck an den Punkt, von dem man
   kam - sonst landet man beim Weitertabben wieder im gerade
   geschlossenen Panel. */
document.addEventListener('focusin', function (e) {
  var ziel = e.target.closest ? e.target.closest('.dn-nav__item') : null;
  document.querySelectorAll('.dn-nav__item').forEach(function (li) {
    var link = li.querySelector('.dn-nav__link[aria-controls]');
    if (!link) return;
    if (li === ziel) {
      if (!li.hasAttribute('data-dn-zu')) link.setAttribute('aria-expanded', 'true');
    } else {
      li.removeAttribute('data-dn-zu');
      if (!li.matches(':hover')) link.setAttribute('aria-expanded', 'false');
    }
  });
  offenPflegen();
});

document.addEventListener('keydown', function (e) {
  if (e.key !== 'Escape') return;
  var offen = document.querySelector('.dn-nav__link[aria-expanded="true"]');
  if (!offen) return;
  var li = offen.parentElement;

  /* Die Marke muss vor dem Zurueckgeben des Fokus stehen, sonst greift
     :focus-within und das Panel geht im selben Atemzug wieder auf. */
  li.setAttribute('data-dn-zu', '');

  var nav = document.querySelector('desktop-navigation');
  if (nav && typeof nav.closeDropdown === 'function') {
    nav.closeDropdown(li);
  }
  offen.setAttribute('aria-expanded', 'false');
  offenPflegen();
  offen.focus();

  li.addEventListener('pointerenter', function () {
    li.removeAttribute('data-dn-zu');
  }, { once: true });
});

/* Verlaesst der Fokus den Punkt, faellt die Sperre - beim naechsten
   Hineinspringen soll das Panel wieder aufgehen. */
document.addEventListener('focusout', function (e) {
  var li = e.target.closest ? e.target.closest('.dn-nav__item[data-dn-zu]') : null;
  if (!li) return;
  setTimeout(function () {
    if (!li.contains(document.activeElement)) li.removeAttribute('data-dn-zu');
  }, 0);
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}
document.addEventListener('shopify:section:load', boot);
  })();
